export const USER_STATUS = {
  NOT_PARTICIPATING: 'NOT_PARTICIPATING',
  PARTICIPATING: 'PARTICIPATING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
}

export const enum LOCALE {
  KO = 'KO_KR',
  EN = 'EN_US',
}
